export default __webpack_public_path__ + "static/media/staff3.8b089744.jpg";